import { RouteEnum } from '@/models/route/Route.model.ts';

export const SYSTEM_ROUTS = [
  '/logout',
  RouteEnum.LOGIN_SUCCESSFUL,
  RouteEnum.NOT_AUTHORIZED,
  RouteEnum.NOT_FOUND,
];
